export default "__VITE_ASSET__R4KZJwgf__"